export default "__VITE_ASSET__DjUl1_tr__"